/*
 * @Author: huangzeshen
 * @Date: 2023-12-25 13:54:12
 * @LastEditors: huangzeshen
 * @LastEditTime: 2024-03-28 14:05:03
 * @FilePath: /waton-mobile/src/App.tsx
 * @Description: 
 */
import { BrowserRouter } from "react-router-dom"
import Router from "./routers"
import './i18n'

export default function App() {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
}
